<div class="p-xxl-5 m-5" >
  
    @if(loginForm){
        <div class="login-wrapper m-auto border bg-light p-5 p-b-1 shadow-sm rounded">            
            <h1 class="text-dark-emphasis">
              <img src="assets/gofreight/logo.png" alt="Mogo Portal" class="img-fluid mb-4">
            </h1>
            <form [formGroup]="loginForm" class="mb-2 text-start border-top pt-3">
                <div class="mb-3 ">
                    <label for="userName" class="form-label">Username</label>
                    <input type="text" class="form-control" id="userName" formControlName="userName" placeholder="Username">
                </div>
                <div class="mb-3">
                    <label for="password" class="form-label">Password</label>
                    <input type="password" class="form-control" id="password" formControlName="password" placeholder="Password">
                </div>
                <button type="submit" (click)="submit()" class="btn btn-primary w-100">Login</button>
                <p class="mt-3 text-center text-danger">{{ loginErrorMessage$ | async}}</p>
            </form>
        </div>
    }

</div>
